export { default as useInterval } from './useInterval';
export * from './useInterval';
//# sourceMappingURL=index.js.map